import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { reviewTypeOptions } from '@/module/Nomen/ReviewType/model/ReviewTypeModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type ReviewTypeSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function ReviewTypeSelectControl<T extends FieldValues>(props: ReviewTypeSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(reviewTypeOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
